<template>
  <v-container>
    <!-- ตารางรายชื่อกลุ่มลูกค้า -->
    <v-card elevation="0" width="100%" height="100%">
      <v-card-title style="font-weight: bold; font-size: 24px; line-height: 32px; color: #333333;" v-if="!MobileSize">จัดการกลุ่มลูกค้า</v-card-title>
      <v-card-title class="px-0" style="font-weight: bold; font-size: 18px; line-height: 32px; color: #333333;" v-else>
        <v-icon color="#27AB9C" class="mr-2" @click="backtoMenu()">mdi-chevron-left</v-icon> จัดการกลุ่มลูกค้า
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" class="py-0 pr-2">
            <a-tabs @change="getGroupCustomer">
              <a-tab-pane :key="0"><span slot="tab">ทั้งหมด <a-tag color="#27AB9C" style="border-radius: 8px;">{{ countAll }}</a-tag></span></a-tab-pane>
              <a-tab-pane :key="1"><span slot="tab">กำลังใช้งาน <a-tag color="#1AB759" style="border-radius: 8px;">{{ countActive }}</a-tag></span></a-tab-pane>
              <a-tab-pane :key="2"><span slot="tab">ปิดการใช้งาน <a-tag color="#F5222D" style="border-radius: 8px;">{{ countInActive }}</a-tag></span></a-tab-pane>
            </a-tabs>
          </v-col>
          <v-col :cols="MobileSize || IpadSize ? 12 : IpadProSize ? 8 : 6" class="" :class="!MobileSize && !IpadSize  ? 'pl-0 pr-3 mb-3 pt-3' : 'mb-4 pt-3'" v-if="disableTable === false">
            <v-text-field v-model="search" placeholder="ค้นหากลุ่มลูกค้า" outlined dense hide-details>
              <v-icon slot="append" color="#27AB9C">mdi-magnify</v-icon>
            </v-text-field>
          </v-col>
          <v-col cols="12" align="end" class="pt-0" v-if="MobileSize">
            <v-btn color="#27AB9C" dark class="mr-2" block  @click="addGroupCustomer()"><v-icon>mdi-plus</v-icon> เพิ่มกลุ่มลูกค้า</v-btn>
          </v-col>
          <v-col cols="12" class="pt-2 pb-3" align="start">
            <v-row dense>
              <v-col :cols="MobileSize ? 12 : IpadSize ? 8 : 6" class="pt-5" v-if="disableTable === false">
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-if="stateStatus === 0">รายการกลุ่มลูกค้าทั้งหมด {{ showCountGroupCustomer }} รายการ</span>
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="stateStatus === 1">รายการกลุ่มลูกค้าที่กำลังใช้งานทั้งหมด {{ showCountGroupCustomer }} รายการ</span>
                <span style="font-size: 16px; line-height: 24px; align-items: center; color: #333333; font-weight: 600" v-else-if="stateStatus === 2">รายการกลุ่มลูกค้าที่ปิดการใช้งานทั้งหมด {{ showCountGroupCustomer }} รายการ</span>
              </v-col>
              <v-col cols="6" class="pt-2" v-if="disableTable === true"></v-col>
              <v-col :cols="IpadSize ? 4 : 6" align="end" class="pt-2" v-if="!MobileSize">
                <v-btn class="px-2" color="#27AB9C" dark @click="addGroupCustomer()"><v-icon>mdi-plus</v-icon> เพิ่มกลุ่มลูกค้า</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="disableTable === false" class="mt-2">
            <v-data-table
            :headers="headers"
            :items="DataTable"
            :search="search"
            :page.sync="page"
            @pagination="countGroupCustomer"
            no-results-text="ไม่พบรายชื่อกลุ่มลูกค้า"
            no-data-text="ไม่มีรายชื่อกลุ่มลูกค้าในตาราง"
            :footer-props="{'items-per-page-text':'จำนวนแถว'}"
            @update:items-per-page="itemsPerPage"
            :items-per-page="10"
            class="elevation-1"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                {{  formatDateTH(item.created_at) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                <span v-if="item.status === 'active'">
                  <v-chip small color="#F0F9EE" text-color="#1AB759">กำลังใช้งาน</v-chip>
                </span>
                <span v-else-if="item.status === 'inactive'">
                  <v-chip small color="#F7D9D9" text-color="#F5222D">ปิดการใช้งาน</v-chip>
                </span>
              </template>
              <template v-slot:[`item.manages`]="{ item }">
                <v-row>
                  <v-col class="pr-0">
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs" v-on="on"
                          x-small @click="editGroupCustomer(item)"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          outlined class="pt-4 pb-4"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                          >
                            <v-icon color="#27AB9C" :size="18">mdi-pencil-outline</v-icon>
                          </v-btn>
                        </template>
                      <span>แก้ไข</span>
                    </v-tooltip>
                  </v-col>
                  <v-col class="pl-0">
                    <v-tooltip top color="#27AB9C">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :disabled="item.have_customer === 'yes'"
                          v-bind="attrs" v-on="on"
                          x-small
                          @click="deleteGroupCustomer(item)"
                          style="border: 1px solid #F2F2F2; box-sizing: border-box; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04); border-radius: 4px;"
                          outlined class="pt-4 pb-4"
                          :style="IpadProSize ? 'max-width: 24px; max-height: 24px;' : IpadSize ? 'max-width: 16px; max-height: 16px;' : 'max-width: 32px; max-height: 32px;'"
                          >
                            <v-icon color="#27AB9C" :size="18">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                      <span>ลบ</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-row>
                  <v-col cols="3">
                    <v-switch :disabled="item.have_customer === 'yes'" :ripple="false" class="hide-background-hover align-center custom-switch"
                    v-model="item.status" value="active" color="#52C41A" inset hide-details
                    @click="turnOnOffGroupCustomer(item)"></v-switch>
                  </v-col>
                  <v-col cols="9" v-if="item.have_customer === 'yes'">
                    <span style="font-size: 12px; color: #F5222D;">ถูกใช้งานอยู่</span>
                  </v-col>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" v-else>
            <v-row justify="center" align-content="center">
              <v-col cols="12" md="12" align="center">
                <div class="my-5">
                  <v-img src="@/assets/Gracz/Customer/emptyGroupCustomer.png" max-height="500px" max-width="500px" height="100%" width="100%" contain aspect-ratio="2"></v-img>
                </div>
                <h2 v-if="stateStatus === 0" style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อกลุ่มลูกค้า</b></h2>
                <h2 v-if="stateStatus === 1" style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อกลุ่มลูกค้าที่กำลังการใช้งาน</b></h2>
                <h2 v-if="stateStatus === 2" style="padding-top: 20px; padding-bottom: 50px; color: #27AB9C;"><b>คุณยังไม่มีรายชื่อกลุ่มลูกค้าที่ปิดการใช้งาน</b></h2>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- dialog เพิ่ม แก้ไข กลุ่มลูกค้า -->
    <v-dialog v-model="openManageGroupCustomer" width="588" persistent>
      <v-card>
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <v-row>
            <v-col class="d-flex justify-space-around">
              <v-toolbar-title><span style="color: #27AB9C;" :class="MobileSize ? 'title-mobil' : ''"><b>{{ title }}</b></span></v-toolbar-title>
            </v-col>
          </v-row>
          <v-btn fab small @click="cancel()" icon><v-icon color="#27AB9C">mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-container grid-list-xs>
          <v-row class="px-5">
            <v-col cols="12">
              <v-img class="float-left" src="@/assets/Gracz/Customer/groupCustomer.png" contain width="60px" height="60px"></v-img>
              <v-card-title style="font-weight: bold; font-size: 18px; line-height: 26px; color: #333333;">{{mainTitle}}รายชื่อกลุ่มลูกค้า</v-card-title>
            </v-col>
          </v-row>
          <v-form ref="form">
            <v-row class="pt-6" no-gutters justify="center">
              <v-col cols="9">
                <v-text-field maxlength="20" :counter="20" :rules="Rules.channel" class="pr-3" placeholder="ระบุชื่อกลุ่มลูกค้า" outlined dense v-model="channelName" ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="px-5">
            <v-spacer></v-spacer>
            <v-btn outlined color="#27AB9C" @click="cancel()">ยกเลิก</v-btn>
            <v-btn class="white--text" color="#27AB9C" @click="confirm()">บันทึก</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- dialog comfirm เพิ่ม แก้ไข กลุ่มลูกค้า -->
    <v-dialog  v-model="dialogConfirmManageGroupCustomer" width="400" persistent>
      <v-card align="center" class="rounded-lg">
        <v-toolbar color="#BDE7D9" dark dense elevation="0">
          <span class="flex text-center ml-5" style="font-size:20px"><font color="#27AB9C">{{title}}</font></span>
          <v-btn
            icon
            dark
            @click="dialogConfirmManageGroupCustomer = false"
            >
            <v-icon  color="#27AB9C">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <br/><br/>
        <v-card-text >
          <span>คุณต้องการ{{title}}นี้ ใช่หรือไม่ ?</span>
        </v-card-text>
        <v-card-actions >
      <v-container >
        <v-btn dense  dark outlined color="#27AB9C" class="pl-7 pr-7 mt-2" @click="closeConfirmManageDialog()">ยกเลิก</v-btn>
        <v-btn dense  color="#27AB9C" class="ml-4 mt-2 pl-8 pr-8 white--text" @click="confirmManageGroupCustomer()">ตกลง</v-btn>
      </v-container>
      </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { Decode } from '@/services'
import moment from 'moment'
export default {
  data () {
    return {
      lazy: false,
      stateStatus: 0,
      showCountGroupCustomer: 0,
      countAll: 0,
      countActive: 0,
      countInactive: 0,
      pageCount: 5,
      page: 1,
      itemsPerPage: 10,
      DataTable: [],
      groupCustomerList: [],
      disableTable: true,
      search: '',
      toggle_active: '',
      headers: [
        { text: 'ชื่อ', value: 'channel_name', filterable: true, width: '120px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'วันที่สร้าง', value: 'created_at', filterable: true, width: '140px', sortable: false, class: 'backgroundTable fontTable--text' },
        { text: 'สถานะ', value: 'status', filterable: false, sortable: false, width: '50px', class: 'backgroundTable fontTable--text' },
        { text: 'จัดการ', value: 'manages', filterable: false, sortable: false, width: '120px', class: 'backgroundTable fontTable--text' },
        { text: 'ปิด - เปิด การใช้งาน', value: 'activeStatus', sortable: false, align: 'center', width: '180px', class: 'backgroundTable fontTable--text' }
      ],
      openManageGroupCustomer: false,
      dialogConfirmManageGroupCustomer: false,
      mainTitle: '',
      title: '',
      userDetailSelling: '',
      customerData: '',
      channelName: '',
      channelId: '',
      Rules: {
        channel: [
          v => !!v || 'กรุณากรอกชื่อกลุ่มลูกค้า',
          v => v.length <= 25 || 'กรอกชื่อกลุ่มลูกค้าได้ไม่เกิน 20 ตัวอักษร'
        ]
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    MobileSize (val) {
      if (val === true) {
        this.$router.push('/Order/ManageGroupCustomerMobile').catch(() => {})
      } else {
        this.$router.push('/Order/ManageGroupCustomer').catch(() => {})
      }
    },
    stateStatus (val) {
      if (val === 0) {
        this.DataTable = this.groupCustomerList.all_channel !== undefined ? this.groupCustomerList.all_channel : []
        if (this.DataTable.length === 0) {
          this.disableTable = true
        } else {
          this.disableTable = false
        }
      } else if (val === 1) {
        this.DataTable = this.groupCustomerList.active_channel !== undefined ? this.groupCustomerList.active_channel : []
        if (this.DataTable.length === 0) {
          this.disableTable = true
        } else {
          this.disableTable = false
        }
      } else if (val === 2) {
        this.DataTable = this.groupCustomerList.inactive_channel !== undefined ? this.groupCustomerList.inactive_channel : []
        if (this.DataTable.length === 0) {
          this.disableTable = true
        } else {
          this.disableTable = false
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  created () {
    this.$EventBus.$emit('changeNav')
    if (localStorage.getItem('oneData') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (localStorage.getItem('UserDetailSelling') !== null) {
        this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      this.getData()
    }
  },
  methods: {
    backtoMenu () {
      if (this.MobileSize) {
        this.$router.push({ path: '/Order/SellerShopMobile' }).catch(() => {})
      } else {
        this.$router.push({ path: '/Order/SellerShop' }).catch(() => {})
      }
    },
    getGroupCustomer (item) {
      this.stateStatus = item
      this.page = 1
    },
    async getData () {
      this.$store.commit('openLoader')
      this.countAll = 0
      this.countActive = 0
      this.countInActive = 0
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id
      }
      await this.$store.dispatch('actionsGraczListChannel', data)
      var response = await this.$store.state.ModuleGraczChannel.stateGraczListChannel
      if (response.message === 'Get list channel success') {
        this.$store.commit('closeLoader')
        this.groupCustomerList = response.data
        this.countAll = response.data.total_all
        this.countActive = response.data.total_active
        this.countInActive = response.data.total_inactive
        if (this.stateStatus === 0) {
          this.DataTable = this.groupCustomerList.all_channel
          if (this.DataTable.length === 0) {
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        } else if (this.stateStatus === 1) {
          this.DataTable = this.groupCustomerList.active_channel
          if (this.DataTable.length === 0) {
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        } else if (this.stateStatus === 2) {
          this.DataTable = this.groupCustomerList.inactive_channel
          if (this.DataTable.length === 0) {
            this.disableTable = true
          } else {
            this.disableTable = false
          }
        }
      } else {
        this.$store.commit('closeLoader')
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async turnOnOffGroupCustomer (item) {
      var shopData = this.userDetailSelling
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        channel_id: item.channel_id,
        channel_status: item.status === null ? 'inactive' : item.status
      }
      var text = item.status === null ? 'ปิดการใช้งานกลุ่มลูกค้าสำเร็จ' : 'เปิดการใช้งานกลุ่มลูกค้าสำเร็จ'
      await this.$store.dispatch('actionsGraczTurnOnOffChannel', data)
      var response = await this.$store.state.ModuleGraczChannel.stateGraczTurnOnOffChannel
      if (response.message === 'Update channel status success') {
        this.$store.commit('closeLoader')
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        this.$swal.fire({ icon: 'success', text: text, showConfirmButton: false, timer: 2000 })
        this.getData()
      } else {
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    addGroupCustomer () {
      this.channelName = ''
      this.openManageGroupCustomer = !this.openManageGroupCustomer
      this.mainTitle = 'เพิ่ม'
      this.title = 'เพิ่มกลุ่มลูกค้า'
      this.$refs.form.resetValidation()
    },
    editGroupCustomer (item) {
      this.channelName = item.channel_name
      this.channelId = item.channel_id
      this.openManageGroupCustomer = !this.openManageGroupCustomer
      this.mainTitle = 'แก้ไข'
      this.title = 'แก้ไขกลุ่มลูกค้า'
    },
    deleteGroupCustomer (item) {
      this.mainTitle = 'ลบ'
      this.title = 'ลบกลุ่มลูกค้า'
      this.channelId = item.channel_id
      this.dialogConfirmManageGroupCustomer = true
    },
    countGroupCustomer (pagination) {
      this.showCountGroupCustomer = pagination.itemsLength
    },
    confirm () {
      this.dialogConfirmManageGroupCustomer = !this.dialogConfirmManageGroupCustomer
      this.openManageGroupCustomer = !this.openManageGroupCustomer
    },
    cancel () {
      this.$refs.form.resetValidation()
      this.openManageGroupCustomer = !this.openManageGroupCustomer
    },
    confirmManageGroupCustomer () {
      this.$store.commit('openLoader')
      var shopData = this.userDetailSelling
      if (this.title === 'เพิ่มกลุ่มลูกค้า') {
        this.create(shopData)
      } else if (this.title === 'ลบกลุ่มลูกค้า') {
        this.delete(shopData)
      } else {
        this.edit(shopData)
      }
    },
    async create (shopData) {
      this.$store.commit('openLoader')
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        channel_name: this.channelName
      }
      await this.$store.dispatch('actionsGraczCreateChannel', data)
      var response = await this.$store.state.ModuleGraczChannel.stateGraczCreateChannel
      if (response.message === 'Create channel success') {
        this.$store.commit('closeLoader')
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        this.$swal.fire({ icon: 'success', text: 'เพิ่มกลุ่มลูกค้าสำเร็จ', showConfirmButton: false, timer: 2000 })
        this.getData()
      } else {
        this.$store.commit('closeLoader')
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async edit (shopData) {
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        channel_id: this.channelId,
        channel_name: this.channelName
      }
      await this.$store.dispatch('actionsGraczEditChannel', data)
      var response = await this.$store.state.ModuleGraczChannel.stateGraczEditChannel
      if (response.message === 'Update channel success') {
        this.$store.commit('closeLoader')
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        this.$swal.fire({ icon: 'success', text: 'แก้ไขกลุ่มลูกค้าสำเร็จ', showConfirmButton: false, timer: 2000 })
        this.getData()
      } else {
        this.$store.commit('closeLoader')
        this.dialogConfirmManageGroupCustomer = false
        this.openManageGroupCustomer = false
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    async delete (shopData) {
      const data = {
        seller_shop_id: shopData.seller_shop_id,
        channel_id: this.channelId
      }
      console.log(data)
      await this.$store.dispatch('actionsGraczDeleteChannel', data)
      var response = await this.$store.state.ModuleGraczChannel.stateGraczDeleteChannel
      // var response = { result: 'SUCCESS' }
      if (response.result === 'SUCCESS') {
        this.dialogConfirmManageGroupCustomer = false
        this.$swal.fire({ icon: 'success', text: 'ลบกลุ่มลูกค้าสำเร็จ', showConfirmButton: false, timer: 2000 })
        this.getData()
      } else {
        this.dialogConfirmManageGroupCustomer = false
        if (response.message === 'This user is unauthorized.') {
          this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else if (response.message === 'Not access this function.') {
          this.$swal.fire({ icon: 'warning', text: 'มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
          window.location.assign('/')
        } else {
          var [msg, iconMsg] = this.getErrorMsg(response.message)
          this.$swal.fire({ icon: iconMsg, text: msg, showConfirmButton: false, timer: 2000 })
        }
      }
    },
    formatDateTH (date) {
      var year = moment(date).locale('TH').add('Year', 543).format('YYYY')
      var dateTH = moment(date).locale('TH').format('D MMMM ' + year)
      return dateTH
    },
    getErrorMsg (msg) {
      if (msg === 'This user is unauthorized.') {
        return ('กรุณาเข้าสู่ระบบใหม่อีกครั้ง', 'warning')
      } else if (msg === 'Parameter Missing') {
        return ['ข้อมูลขาดหาย', 'warning']
      } else if (msg === 'Not access this function.') {
        return ['มีการเปลี่ยนแปลงตำแหน่ง หรือเปลี่ยนแปลงสิทธิ์การใช้งาน กรุณาลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Employee not found. Please check and try again.') {
        return ['ไม่พบพนักงาน โปรดเช็คแล้วลองใหม่อีกครั้ง', 'warning']
      } else if (msg === 'Not Found Seller Shop') {
        return ['ไม่พบร้านค้า', 'warning']
      } else if (msg === 'Channel name is already exists.') {
        return ['มีชื่อกลุ่มลูกค้านี้ถูกใช้อยู่', 'warning']
      } else if (msg === 'Your channel can insert maximum 20 channel.') {
        return ['ไม่สามารถเพิ่มกลุ่มลูกค้าได้ เนื่องจากมีกลุ่มลูกค้าครบ 20 กลุ่มแล้ว', 'warning']
      } else if (msg === 'Channel name must not exceed 20 characters.') {
        return ['กรอกชื่อกลุ่มลูกค้าได้ไม่เกิน 20 ตัวอักษร', 'warning']
      } else {
        return [msg, 'error']
      }
    },
    closeConfirmManageDialog () {
      this.dialogConfirmManageGroupCustomer = !this.dialogConfirmManageGroupCustomer
    }
  }
}
</script>
<style scoped>
.theme--light.v-input {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>
<style lang="scss" scoped>
  ::v-deep table {
    tbody {
      tr {
        td:nth-child(4) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 140px;
          z-index: 10;
          background: white;
        }
        td:nth-child(5) {
          position: sticky !important;
          position: -webkit-sticky !important;
          right: -20px;
          z-index: 10;
          background: white;
        }
      }
    }
    thead {
      tr {
        th:nth-child(4) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: 140px;
        }
        th:nth-child(5) {
          z-index: 11;
          background: white;
          position: sticky !important;
          position: -webkit-sticky !important;
          right: -20px;
        }
      }
    }
  }
</style>
